module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/сupboard-0256f9549063c4db4ebcc2c4c8de93ef.svg";